import { useMemo, type JSX } from "react";
import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { formatCurrencyFromCentsToReais } from "@/lib/helpers/currency";

const AboutReferralPage = (): JSX.Element => {
  const { flags } = useRouteContext({ from: "__root__" });

  const referralValue = useMemo(
    () => flags["valor-do-gentileza-gera-gentileza"],
    [flags],
  );

  const formattedReferralValue = useMemo(
    () => formatCurrencyFromCentsToReais(referralValue * 100),
    [referralValue],
  );
  return (
    <>
      <HeaderRoot>
        <HeaderButton align="start" icon={Left} />
        <HeaderTitle title="Sobre" align="center" />
      </HeaderRoot>
      <Page>
        <p className="text-left text-xl text-neutral-600 font-medium w-full">
          Gentileza gera gentileza
        </p>
        <div className="flex flex-col gap-6 text-neutral-500 mt-2">
          <p className="text-left">
            O programa Gentileza Gera Gentileza da Livance permite que você, como membro,
            indique profissionais da saúde para se juntarem à nossa comunidade e seja
            recompensado por isso.{" "}
            <b>
              Ao indicar um colega que se torne membro, você recebe um crédito de{" "}
              {formattedReferralValue} na sua próxima fatura.
            </b>
          </p>
          <p className="text-left">
            Esta é a nossa maneira de agradecer e incentivar você a compartilhar a
            experiência Livance com outros profissionais, contribuindo para o crescimento
            de uma rede de consultórios compartilhados de alta qualidade.{" "}
          </p>
          <p className="text-left">
            Participe e ajude a transformar a experiência de atendimentos em consultórios!
          </p>
          <p className="text-left">
            Para indicar, clique no link de indicação, compartilhe com seu colega e
            aguarde a confirmação do cadastro e visita agendada. Juntos, vamos construir
            uma comunidade ainda mais forte e colaborativa.
          </p>
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/referral/about")({
  component: AboutReferralPage,
});
